import { Avatar, Box, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    useGetCourseDetailMutation,
    useGetCourseMasterMutation,
    useGetCourseTrackListMutation,
    useGetPointsMutation,
    useGetProjectSubmissionMutation,
    useGetQuizMasterMutation,
    useGetUserInfoMutation,
} from "../../../../apiSlice";
import PieChart from "../PieChart";
import bronze from "./bronze.png";
import gold from "./gold.png";
import legendary from "./legendary.png";
import platinum from "./platinum.png";
import profile from "./profile.png";
import "./ProfileBar.css";
import projectThumb from "./projects.png";
import quizThumb from "./quiz.png";
import courseThumb from "./courseThumbb.png";
import silver from "./silver.png";
import { useParentalInfoCheck } from "../../../context/ParentalInfoCheck";
import { API_BannerURL } from "../../../../config";

const ProfileBar = () => {
    const navigate = useNavigate();
    const [earnedPoints, setEarnedPoints] = useState(0);
    const [loading, setLoading] = useState(true);
    const [studentDataAPI] = useGetUserInfoMutation();
    const [studentPointsAPI] = useGetPointsMutation();
    const [studentQuizMasterAPI] = useGetQuizMasterMutation();
    const [studentProjectDataAPI] = useGetProjectSubmissionMutation();
    const [studentCourseMasterAPI] = useGetCourseMasterMutation();
    const [studentCourseDetailAPI] = useGetCourseDetailMutation();
    const [studentCourseTrackListAPI] = useGetCourseTrackListMutation();
    const [userData, setUserData] = useState();
    const [quizData, setQuizData] = useState();
    const [projectsData, setProjectsData] = useState();
    // const [courseData, setCourseData] = useState([]);
    const [courseTrackData, setCourseTrackData] = useState([]);
    const [courseDetails, setCourseDetails] = useState([]);
    const { isParentInfoPresent, snackbarOpen, setSnackbarOpen } =
        useParentalInfoCheck();

    console.log("PARENT CONTEXT =========== ", isParentInfoPresent);

    const handleNavigate = (path) => {
        // this logic now on hold
        // if (isParentInfoPresent) {
        //     navigate(path);
        // } else {
        //     setSnackbarOpen(true);
        // }
        navigate(path);
    };

    useEffect(() => {
        const fetchData = async () => {
            if (loading) {
                try {
                    setLoading(true);

                    const studentData = await studentDataAPI();
                    setUserData(studentData.data[0]);

                    const points = await studentPointsAPI();
                    setEarnedPoints(points.data);

                    const courseMaster = await studentCourseMasterAPI();

                    const filteredCourseData = courseMaster?.data?.filter(
                        (e) => e.subject === studentData.data[0]?.className
                    );
                    // .slice(0, 1);
                    // setCourseData(courseMaster);
                    console.log("filteredCourseData", filteredCourseData);

                    /**
                     * Filtering the IDs from the main "Course Data" and embedding it to an array
                     * These are the ids of course for particular class of a student
                     */
                    const filteredCourseIds = filteredCourseData.map(
                        (course) => course.courseId
                    );

                    console.log(
                        "filteredCourseIds",
                        filteredCourseIds,
                        typeof filteredCourseIds
                    );

                    const courseD = await studentCourseDetailAPI();

                    console.log("courseD", courseD.data);

                    /**
                     * Filtering `Course Detials` on basis of, if the id is prsent in the {filteredCouresIds}
                     * It is to ensure that all the course are filtered according to the IDs
                     * This will give us the total `number of course`
                     */
                    const filteredCourseDetails = courseD?.data?.map(
                        (course, id) => {
                            if (filteredCourseIds.includes(course.courseId))
                                return course;
                        }
                    );

                    setCourseDetails(filteredCourseDetails);

                    // This is the total courses that will be there for any particular class of student
                    console.log("filteredCourseDetails", filteredCourseDetails);

                    const courseT = await studentCourseTrackListAPI();

                    /**
                     * Filtering the data from the {courseT} which is the track list of course
                     * Filtering it according to the IDs from {filteredCouresIds} and {userId}
                     * This will give us the `Total Progress`
                     */
                    const filteredCourseTrack = courseT?.data?.map(
                        (track, id) => {
                            if (
                                filteredCourseIds.includes(track.courseId) &&
                                track.userID === studentData.data[0]?.userId
                            )
                                return track;
                        }
                    );
                    setCourseTrackData(filteredCourseTrack);

                    console.log("courseTrackData", courseTrackData);

                    const quizMaster = await studentQuizMasterAPI();
                    setQuizData(quizMaster.data);

                    const projectSubmission = await studentProjectDataAPI();
                    setProjectsData(projectSubmission.data);
                } catch (error) {
                    console.error("Error fetching data:", error);
                } finally {
                    setLoading(false);
                }
            }
        };
        fetchData();
    }, [loading]);

    /**
     * This is the total number of modules present in a course
     */
    const courseTotalModule = courseDetails?.length;

    /**
     * This is the total progress done i.e, total number of module completed
     */
    const courseProgress =
        Object.keys(courseTrackData).length === 0
            ? 0
            : courseTrackData?.filter((e) => e?.courseCompleted === true)
                  .length;

    /**
     * This is the module remaining i.e, total number of incomplete module
     */
    const incompletePortion = courseTotalModule - courseProgress;

    /**
     * Here we are calculating percentage
     */
    const percentCompleted = Math.round(
        (courseProgress / courseTotalModule) * 100
    );

    // total number
    console.log("Course Total Module", courseTotalModule);

    // completed portion of the course
    console.log("Course Progress", courseProgress);

    console.log(
        "pb",
        courseTotalModule,
        courseProgress,
        incompletePortion,
        percentCompleted
    );

    console.log(
        "courseTotalModule",
        courseTotalModule,
        "courseProgress",
        courseProgress,
        "incompletePortion",
        incompletePortion,
        "percentCompleted",
        percentCompleted
    );

    return (
        <>
            <Box
                bgcolor="white"
                sx={{
                    left: "60px",
                    position: "absolute",
                    width: "200px",
                    height: "100vh",
                    padding: "20px",
                    zIndex: "0",
                }}
            >
                <Stack spacing={2} direction="column">
                    <Stack direction="column" textAlign="center" spacing={1}>
                        <Box alignSelf="center" position="relative">
                            <Avatar
                                alt={userData?.name}
                                src={
                                    API_BannerURL.slice(0, -1) +
                                    userData?.profilePicture
                                }
                                sx={{
                                    aspectRatio: "1/1",
                                    width: "80px",
                                    height: "80px",
                                    borderRadius: "100%",
                                }}
                            />
                            <Box position="absolute" top="0" right="-20px">
                                <img
                                    src={
                                        earnedPoints >= 2200
                                            ? legendary
                                            : earnedPoints >= 2000
                                            ? platinum
                                            : earnedPoints >= 1500
                                            ? gold
                                            : earnedPoints >= 750
                                            ? silver
                                            : earnedPoints >= 0
                                            ? bronze
                                            : ""
                                    }
                                    style={{ height: "auto", width: "50px" }}
                                />
                            </Box>
                        </Box>
                        <Stack spacing={0.5}>
                            <Typography variant="h3">
                                {userData?.firstName} {userData?.lastName}
                            </Typography>
                            <Typography variant="subtitle1">
                                {userData?.schoolName}
                            </Typography>
                            <Typography variant="subtitle1" mt="5px">
                                Class: {userData?.className}
                            </Typography>
                        </Stack>
                    </Stack>
                    <Stack spacing={1}>
                        <Box
                            padding="10px"
                            display="flex"
                            border="1px solid #F2F2F2"
                            borderRadius="6px"
                            flexDirection="column"
                            width="100%"
                            justifyContent="space-between"
                            gap="10px"
                            onClick={() => navigate("/StudentDashboard/Quiz")}
                        >
                            <Typography variant="h4">Course Status</Typography>

                            <Box height="110px" position="relative">
                                <PieChart
                                    apiData={[
                                        {
                                            label: "completed",
                                            value: courseProgress,
                                        },
                                        {
                                            label: "incomplete",
                                            value: incompletePortion,
                                        },
                                    ]}
                                />
                                <Box
                                    position="absolute"
                                    top="0"
                                    height="110px"
                                    width="100%"
                                    display="flex"
                                    flexDirection="column"
                                    alignItems="center"
                                    justifyContent="center"
                                    textAlign="center"
                                >
                                    <Typography variant="h5">
                                        {percentCompleted}%
                                    </Typography>
                                    <Typography variant="subtitle1">
                                        Complete
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                    </Stack>
                    <Stack>
                        <Box
                            sx={{ cursor: "pointer" }}
                            padding="10px"
                            display="flex"
                            border="1px solid #F2F2F2"
                            borderRadius="6px"
                            flexDirection="column"
                            width="100%"
                            justifyContent="space-between"
                            gap="10px"
                            onClick={() =>
                                handleNavigate("/StudentDashboard/Quiz")
                            }
                        >
                            <Typography variant="h4">Quiz</Typography>
                            <img
                                src={quizThumb}
                                style={{
                                    height: "50px",
                                    width: "100%",
                                    objectFit: "cover",
                                    borderRadius: "6px",
                                }}
                            />
                        </Box>
                        {/* {loading ? (
                            <Box display="flex" justifyContent="center" alignItems="center" height="200px">
                                <CircularProgress />
                            </Box>
                        ) : (
                            quizData.length > 0 ? quizData?.slice(0, 1)?.map((quiz, index) => (
                                <Stack
                                    onClick={() => {
                                        setQuizData(quiz);
                                        navigate('/StudentDashboard/Quiz/QuizContent')
                                    }}
                                    key={index}
                                    direction="column"
                                    alignItems='flex-start'
                                    spacing={1}
                                    border='1px solid #F2F2F2'
                                    sx={{
                                        padding: '5px',
                                        borderRadius: '6px',
                                        cursor: 'pointer'
                                    }}
                                >

                                    <img
                                        src={quizThumb}
                                        style={{ height: '50px', width: '100%', objectFit: 'cover', borderRadius: '6px' }}
                                    />
                                    <Typography variant="body2" sx={{ flexGrow: 1 }}>
                                        {quiz.quizTittle || `Student ${index + 1}`}
                                    </Typography>
                                    {/* <Typography variant="body2" color="primary">
                                                {projects.status || 0}
                                            </Typography>
                    </Stack>
                    )) : " "
                        )} */}
                    </Stack>
                    <Stack>
                        <Box
                            sx={{ cursor: "pointer" }}
                            padding="10px"
                            display="flex"
                            border="1px solid #F2F2F2"
                            borderRadius="6px"
                            flexDirection="column"
                            width="100%"
                            justifyContent="space-between"
                            gap="10px"
                            onClick={() =>
                                handleNavigate("/StudentDashboard/Projects")
                            }
                        >
                            <Typography variant="h4">Kidpreneur</Typography>
                            <img
                                src={projectThumb}
                                style={{
                                    height: "50px",
                                    width: "100%",
                                    objectFit: "cover",
                                    borderRadius: "6px",
                                }}
                            />
                        </Box>
                        {/* {loading ? (
                            <Box display="flex" justifyContent="center" alignItems="center" height="200px">
                                <CircularProgress />
                            </Box>
                        ) : (
                            projectsData.length > 0 ? projectsData?.slice(0, 1).map((projects, index) => (
                                <Stack
                                    key={projects.projectSubmissionId || index}
                                    direction="column"
                                    alignItems='flex-start'
                                    spacing={1}
                                    border='1px solid #F2F2F2'
                                    sx={{
                                        padding: '5px',
                                        borderRadius: '6px'
                                    }}
                                >

                                    <img
                                        src={projectThumb}
                                        style={{ height: '50px', width: '100%', objectFit: 'cover', borderRadius: '6px' }}
                                    />
                                    <Typography variant="body2" sx={{ flexGrow: 1 }}>
                                        {projects.projectName || `Student ${index + 1}`}
                                    </Typography>
                                    {/* <Typography variant="body2" color="primary">
                                                {projects.status || 0}
                                            </Typography>
                                </Stack>
                            )) : ""
                        )} */}
                    </Stack>
                    <Stack>
                        <Box
                            sx={{ cursor: "pointer" }}
                            padding="10px"
                            display="flex"
                            border="1px solid #F2F2F2"
                            borderRadius="6px"
                            flexDirection="column"
                            width="100%"
                            justifyContent="space-between"
                            gap="10px"
                            onClick={() =>
                                handleNavigate("/StudentDashboard/CourseList")
                            }
                        >
                            <Typography variant="h4">Courses</Typography>
                            <img
                                src={courseThumb}
                                style={{
                                    height: "50px",
                                    width: "100%",
                                    objectFit: "cover",
                                    borderRadius: "6px",
                                }}
                            />
                        </Box>
                        {/* {loading ? (
                            <Box display="flex" justifyContent="center" alignItems="center" height="200px">
                                <CircularProgress />
                            </Box>
                        ) : (
                            projectsData.length > 0 ? projectsData?.slice(0, 1).map((projects, index) => (
                                <Stack
                                    key={projects.projectSubmissionId || index}
                                    direction="column"
                                    alignItems='flex-start'
                                    spacing={1}
                                    border='1px solid #F2F2F2'
                                    sx={{
                                        padding: '5px',
                                        borderRadius: '6px'
                                    }}
                                >

                                    <img
                                        src={projectThumb}
                                        style={{ height: '50px', width: '100%', objectFit: 'cover', borderRadius: '6px' }}
                                    />
                                    <Typography variant="body2" sx={{ flexGrow: 1 }}>
                                        {projects.projectName || `Student ${index + 1}`}
                                    </Typography>
                                    {/* <Typography variant="body2" color="primary">
                                                {projects.status || 0}
                                            </Typography>
                                </Stack>
                            )) : ""
                        )} */}
                    </Stack>
                </Stack>
            </Box>
        </>
    );
};

export default ProfileBar;
